import { RootState } from '../../Application';
import { Condition } from '../../screen/Condition';

export const coachHasSession = new Condition({
  check: (state: RootState) => {
    return state.Session.sessionToken ? true : false;
  },
  failMessage: 'Coach does not have session'
});

export const hasCoachesKey = new Condition({
  check: (state: RootState) => {
    return state.Session.coachesKey ? true : false;
  },
  failMessage: 'CoachesKey not found'
});

export const hasPartnerKey = new Condition({
  check: (state: RootState) => {
    return state.Session.partnersKey ? true : false;
  },
  failMessage: 'partnersKey not found'
});


export const hasProducts = new Condition({
  check: (state: RootState) => {
    return state.Order.products.length > 0 && state.Order.products.some(product => product !== undefined) ;
  },
  failMessage: 'no products in the list'
});